import {Component, Input, OnDestroy} from '@angular/core';
import {Observable, withLatestFrom} from "rxjs";
import {NotificationsStore} from "./notifications.store";
import {AppState} from "../../store/store";
import {selectSites} from "../../store/sites/sites.selectors";
import {Store} from "@ngrx/store";
import {Serializer, Serializers} from "../../interfaces/serializer";
import {Site} from "../../interfaces/site";
import {NotificationComponentObject} from "../../classes/notification-component-object";
import {
  selectNotifications,
  selectNotificationsLoaded,
  selectNotificationsLoading
} from "../../store/notificationCenter/notificationCenter.selectors";
import {selectSite} from "../../store/init/init.selectors";
import {map} from "rxjs/operators";
import {deleteInfoNotifications} from "../../store/notificationCenter/notificationCenter.actions";

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  providers: [NotificationsStore]
})
export class NotificationsComponent implements OnDestroy {
  public readonly site$: Observable<Serializer<Site>> = this._store.select(selectSite);
  public readonly sites$: Observable<Serializers<Site>> = this._store.select(selectSites)
    .pipe(
      withLatestFrom(this.site$),
      map(([sites, site]: [Serializers<Site>, Serializer<Site>]): Serializers<Site> => sites.filter((s: Serializer<Site>): boolean => s.id !== site.id))
    );
  public readonly notifications$: Observable<NotificationComponentObject[]> = this._store.select(selectNotifications);
  public readonly loading$: Observable<boolean> = this._store.select(selectNotificationsLoading);
  public readonly loaded$: Observable<boolean> = this._store.select(selectNotificationsLoaded);

  @Input() public withHeader: boolean = true;
  @Input() public deleteOnDestroy: boolean = false;

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _notificationCenterStore: NotificationsStore
  ) {}

  ngOnDestroy(): void {
    if (this.deleteOnDestroy) {
      this._store.dispatch(deleteInfoNotifications());
    }
  }
}
